import { render, staticRenderFns } from "./ActionLogPage.vue?vue&type=template&id=1b4b22b0&scoped=true&"
import script from "./ActionLogPage.vue?vue&type=script&lang=ts&"
export * from "./ActionLogPage.vue?vue&type=script&lang=ts&"
import style0 from "./ActionLogPage.vue?vue&type=style&index=0&id=1b4b22b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b22b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
